/**
 * Word-level diff helpers used to render old-vs-new text changes as <del>/<ins> HTML.
 * Shared by the applicability-question review dialog; the rulebook review dialog
 * (edit-template.component.ts DisplayReviewDialog) keeps its own historical copy.
 */

export function decodeHtml(html: string): string {
  if (html == null) return "";
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

export function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, "");
}

export function processHtml(html: string): string {
  return stripHtml(decodeHtml(html));
}

export function diff(o, n) {
  var ns = new Object();
  var os = new Object();

  for (var i = 0; i < n.length; i++) {
    if (ns[n[i]] == null) ns[n[i]] = { rows: new Array(), o: null };
    ns[n[i]].rows.push(i);
  }

  for (var i = 0; i < o.length; i++) {
    if (os[o[i]] == null) os[o[i]] = { rows: new Array(), n: null };
    os[o[i]].rows.push(i);
  }

  for (var j in ns) {
    if (
      ns[j].rows.length == 1 &&
      typeof os[j] != "undefined" &&
      os[j].rows.length == 1
    ) {
      n[ns[j].rows[0]] = { text: n[ns[j].rows[0]], row: os[j].rows[0] };
      o[os[j].rows[0]] = { text: o[os[j].rows[0]], row: ns[j].rows[0] };
    }
  }

  for (var i = 0; i < n.length - 1; i++) {
    if (
      n[i].text != null &&
      n[i + 1].text == null &&
      n[i].row + 1 < o.length &&
      o[n[i].row + 1].text == null &&
      n[i + 1] == o[n[i].row + 1]
    ) {
      n[i + 1] = { text: n[i + 1], row: n[i].row + 1 };
      o[n[i].row + 1] = { text: o[n[i].row + 1], row: i + 1 };
    }
  }

  for (var i = n.length - 1; i > 0; i--) {
    if (
      n[i].text != null &&
      n[i - 1].text == null &&
      n[i].row > 0 &&
      o[n[i].row - 1].text == null &&
      n[i - 1] == o[n[i].row - 1]
    ) {
      n[i - 1] = { text: n[i - 1], row: n[i].row - 1 };
      o[n[i].row - 1] = { text: o[n[i].row - 1], row: i - 1 };
    }
  }

  return { o: o, n: n };
}

export function diffString(o: string, n: string): string {
  o = o.replace(/\s+$/, "");
  n = n.replace(/\s+$/, "");

  var out = diff(o == "" ? [] : o.split(/\s+/), n == "" ? [] : n.split(/\s+/));
  var str = "";

  var oSpace = o.match(/\s+/g);
  if (oSpace == null) {
    oSpace = ["\n"];
  } else {
    oSpace.push("\n");
  }
  var nSpace = n.match(/\s+/g);
  if (nSpace == null) {
    nSpace = ["\n"];
  } else {
    nSpace.push("\n");
  }

  if (out.n.length == 0) {
    for (var i = 0; i < out.o.length; i++) {
      str += "<del>" + out.o[i] + oSpace[i] + "</del>";
    }
  } else {
    if (out.n[0].text == null) {
      for (n = 0 as any; (n as any) < out.o.length && out.o[n as any].text == null; (n as any)++) {
        str += "<del>" + out.o[n as any] + oSpace[n as any] + "</del>";
      }
    }

    for (var i = 0; i < out.n.length; i++) {
      if (out.n[i].text == null) {
        str += "<ins>" + out.n[i] + nSpace[i] + "</ins>";
      } else {
        var pre = "";

        for (
          n = (out.n[i].row + 1) as any;
          (n as any) < out.o.length && out.o[n as any].text == null;
          (n as any)++
        ) {
          pre += "<del>" + out.o[n as any] + oSpace[n as any] + "</del>";
        }
        str += " " + out.n[i].text + nSpace[i] + pre;
      }
    }
  }

  return str;
}
